import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HOSTFULLY_ASSIST_PATH } from 'pages/hostfullyAssist/HostfullyAssist.constants';
import { HostfullyLinkContainer } from './IntegrationCell.styles';

const LEARN_MORE_PATHS: Partial<Record<IntegrationEnum, string>> = {
  [IntegrationEnum.HOSTFULLYASSIST]: HOSTFULLY_ASSIST_PATH,
};

const TrialAvailableCta = ({
  integrationId,
}: {
  integrationId: IntegrationEnum;
}) => {
  const { t } = useTranslation();
  const learnMorePath = LEARN_MORE_PATHS[integrationId];

  if (!learnMorePath) {
    return null;
  }

  return (
    <>
      <div>{t('pageIntegrations.table.freeTrialAvailable')}</div>
      <HostfullyLinkContainer>
        <Link
          to={learnMorePath}
          onClick={(e) => e.stopPropagation()}
          data-testid="free-trial-learn-more-link"
        >
          {t('pageIntegrations.table.learnMore')}
        </Link>
      </HostfullyLinkContainer>
    </>
  );
};

export default TrialAvailableCta;
